import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldMultiLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18V5ZM4 6V17H20V6H4Z",
		fill: "#9C9EB6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18 15V10L13 15H18Z",
		fill: "#9C9EB6"
	})]
});
export default SvgFieldMultiLine;
